import React, { Component } from 'react'

import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { withNamespaces } from "react-i18next";
import { isDesktop } from "react-device-detect";
import { connect } from "react-redux";
import Swal from 'sweetalert2';
import MobileCheckIn from './MobileCheckIn';
import LoadingPage from '../../components/LoadingPage/LoadingPage';

import { getDailyMission, getDailyMissionBonuses, claimDailyBonus, claimExtraBonus } from "../../store/ducks/dailyMission/actions";
import moment from 'moment';
import { getVIP } from "../../store/ducks/vip/actions";
import MemberProgress from "../DailyCheckIn/MemberProgress";
import { getMemberProgress, getVipLevelRequirementAndReward } from "../../store/ducks/dailyCheckIn/actions";

export class CheckIn extends Component {
  constructor(props) {
    super(props);
    let vipDetails = JSON.parse(localStorage.getItem('vipDetails'));
    this.state = {
      loading: true,
      mission: [],
      daily_claim_list: [],
      claim_loading: true,
      start_day: "",
      end_day: "",
      vip: (vipDetails && vipDetails.vip) ? vipDetails.vip : [],
      currentVip: 1,
      timeLeft: { hours: 0, minutes: 0, seconds: 0 },
      memberProgress: {
        vipLevel: 0,
        balance: {
          credit: 0,
        },
        day: 0,
        days: Array.from({ length: 7 }).map(() => ({
          canCheckIn: false,
          isCheckedIn: false,
          requiredCredit: 200,
          requiredCreditBalance: 0,
          rewardCredit: 100,
          rewardCoin: 0,
          rewardTotalFreeSpin: 3,
          extraRewardCredit: 100,
          extraRewardCoin: 50,
          extraRewardTotalFreeSpin: 3,
          requiredTurnoverForWithdrawal: 0
        })),
      },
    };
  }

  componentDidMount() {
    this.fetchData();
    this.props.getMemberProgress();

    if (this.props.currentUser?.data?.country_id) {
      this.props.getVipLevelRequirementAndReward({
        country_id: this.props.currentUser.data.country_id,
      });
    }

    const { t } = this.props;
    const vip = this.imageImport(require.context("../../assets/images/vip", false, /\.(gif|png|jpe?g|svg|webp|webm)$/));

    const userVip = this.state.vip.find(vip => vip.level === this.state.memberProgress.vipLevel);
    const lastSeenDate = localStorage.getItem("vipPopupDate");
    const today = new Date().toISOString().split("T")[0];
    
    // Show only once each day
    if(lastSeenDate !== today){
      Swal.fire({
        iconHtml: `<img class="deposit" src="${vip[`vip${userVip.level}.webp`]}" />`,
        icon: "info",
        html: `
          <p>${t('check_in.vip-upgrade')}!</p>
          <span>${t('check_in.current-vip-lvl')} ${t(`vip.vip-${userVip.level}`)}.</span> <br />
          <span>${t('check_in.enjoy-higher-rewards')}</span>
        `,
        confirmButtonText: t("global.ok"),
        showCancelButton: (!isDesktop) ? false : '',
        customClass: {
          container: (isDesktop) ? "swal-check-in-container" : "swal-mobile-container swal-check-in-container",
        },
      });  
      localStorage.setItem("vipPopupDate", today);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.memberProgress !== this.props.memberProgress &&
      this.props.memberProgress &&
      this.props.memberProgress.responseCode === 200 &&
      this.props.memberProgress.data
    ) {
      this.setState({
        ...this.state,
        loading: false,
        memberProgress: this.props.memberProgress.data,
        currentVip: this.props.memberProgress.data.vipLevel,
      });
    }

    if (prevProps.currentUser?.data?.country_id !== this.props.currentUser?.data?.country_id && 
      this.props.currentUser?.data?.country_id
    ) {
      this.props.getVipLevelRequirementAndReward({
        country_id: this.props.currentUser.country_id,
      });
    }
  }

  fetchData = () => {

    this.props.getDailyMission();
    this.props.getDailyMissionBonuses();

    if (localStorage.getItem('vipDetails')) {
      let vipDetails = JSON.parse(localStorage.getItem('vipDetails'));
      let tmpMoment = moment(vipDetails.expired);
      let duration = moment.duration(tmpMoment.diff(moment())).asSeconds();

      if (duration > 0) {
          this.setState({
              vip: vipDetails.vip,
              loading: false
          });

          return false;
      }
    }

    const showVIPData = {};
    this.props.getVIP(showVIPData);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.daily_mission !== undefined && nextProps.daily_mission !== this.props.daily_mission) {
      if (nextProps.daily_mission.data.responseCode === 200 && nextProps.daily_mission.data.msgType === "success") {
        this.setState({
          loading: false,
          mission: nextProps.daily_mission.data.data.result,
          start_day: nextProps.daily_mission.data.data.start_day,
          end_day: nextProps.daily_mission.data.data.end_day
        });
      }
    }

    if (nextProps.daily_mission_bonuses !== undefined && nextProps.daily_mission_bonuses !== this.props.daily_mission_bonuses) {
      if (nextProps.daily_mission_bonuses.data.responseCode === 200 && nextProps.daily_mission_bonuses.data.msgType === "success") {
        this.setState({
          claim_loading: false,
          daily_claim_list: nextProps.daily_mission_bonuses.data.data.result
        });
      }
    }

    if (nextProps.daily_mission_bonus_claim !== undefined && nextProps.daily_mission_bonus_claim !== this.props.daily_mission_bonus_claim) {
      if (nextProps.daily_mission_bonus_claim.data.responseCode === 200 && nextProps.daily_mission_bonus_claim.data.msgType === "success") {
        const { t } = this.props;
        Swal.fire({
          iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/ri:check-fill.svg?color=%2306DB04">' : '',
          icon: "info",
          title: t("global.success"),
          text: t("check_in.bonus-claim"),
          confirmButtonText: t("global.ok"),
          customClass: (!isDesktop) ? {
            container: 'swal-mobile-container sucess',
            icon: 'swal-success-icon'
          } : []
        }).then((result) => {
          this.setState({
            loading: true,
            mission: [],
            daily_claim_list: [],
            claim_loading: true,
            start_day: "",
            end_day: ""
          });
          this.fetchData();
        });
      }
    }

    if (nextProps.daily_mission_extra_bonus_claim !== undefined && nextProps.daily_mission_extra_bonus_claim !== this.props.daily_mission_extra_bonus_claim) {
      if (nextProps.daily_mission_extra_bonus_claim.data.responseCode === 200 && nextProps.daily_mission_extra_bonus_claim.data.msgType === "success") {
        const { t } = this.props;
        Swal.fire({
          iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/ri:check-fill.svg?color=%2306DB04">' : '',
          icon: "info",
          title: t("global.success"),
          text: t("check_in.extra-bonus-claim"),
          confirmButtonText: t("global.ok"),
          customClass: (!isDesktop) ? {
            container: 'swal-mobile-container sucess',
            icon: 'swal-success-icon'
          } : []
        }).then((result) => {
          this.setState({
            loading: true,
            mission: [],
            daily_claim_list: [],
            claim_loading: true,
            start_day: "",
            end_day: ""
          });
          this.fetchData();
        });
      }
    }

    if (nextProps.vip_data !== this.props.vip_data) {
      if (nextProps.vip_data.responseCode === 200) {
        this.setState({
            vip: nextProps.vip_data.data,
            loading: false,
        });

        let expired = moment().add(2, 'minutes');
        let tmpArr = {};
        tmpArr.vip = nextProps.vip_data.data;
        tmpArr.expired = expired.format('YYYYMMDDTHHmmss');
        localStorage.setItem('vipDetails', JSON.stringify(tmpArr));
      }
    }
    return true;
  }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  claimBonusHandler = (id, turnover, date, bonus) => {
    if (localStorage.getItem("accessToken")) {
      if (id === "extra-bonus") {
        let data = {};
        data.id = id;
        data.country_id = this.props.currentUser.country_id;
        data.bonus = bonus;
        this.props.claimExtraBonus(data);
      }
      else {
        // normal daily claim
        let data = {};
        data.id = id;
        data.country_id = this.props.currentUser.country_id;
        data.validate_turnover = turnover;
        data.validate_date = date;
        data.bonus = bonus;
        this.props.claimDailyBonus(data);
      }
    }
    else {
      const { t } = this.props;
      Swal.fire({
        iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/iconamoon:pensive-face-thin.svg?color=%2393a2Aa">' : '',
        icon: "info",
        title: t("global.sorry"),
        text: t("global.login-proceed"),
        confirmButtonText: t("global.ok"),
        showCancelButton: (!isDesktop) ? false : '',
        customClass: (!isDesktop) ? {
          container: "swal-mobile-container sorry",
          icon: "swal-sorry-icon",
        } : []
      });
    }
  }

  handleVipLvl = (vipVal) => {
    this.setState({
      currentVip: vipVal
    })
  }  

  render() {

    const { t } = this.props;
    const { currentVip } = this.state
    const img = this.imageImport(require.context("../../assets/images/check-in", false, /\.(png|jpe?g|svg|webp)$/));
    const icon = this.imageImport(require.context("../../assets/images/icons", false, /\.(png|jpe?g|svg|webp)$/));
    const vip = this.imageImport(require.context("../../assets/images/vip", false, /\.(gif|png|jpe?g|svg|webp|webm)$/));

    let prevPage = this.props.location && this.props.location.state && this.props.location.state.prev ? this.props.location.state.prev : undefined;

    let imageLanguage = '';
    switch (this.props.currentUser.language_code) {
      case "zh-CN":
        imageLanguage = "-cn"
        break;
      case "ms":
        imageLanguage = "-ms"
        break;
      case "id":
        imageLanguage = "-id"
        break;
      default:
        imageLanguage = ""
        break;
    }

    const num_format = { maximumFractionDigits: 2, minimumFractionDigits: 2 };   

    const isCheckInPage = window.location.pathname;

    let vipInfo = [];
    let customizedVip = this.state.vip.filter(val => val.level !== 0);
    
    customizedVip.map((vipval, idx) => {
        vipInfo.push({
            id: idx,
            name: t(`vip.vip-${vipval.level}`),
            img: "vip-" + (vipval.level - 1) + "",
            deposit: new Intl.NumberFormat("en-US", num_format).format(vipval.minDepositTierUpgrade),
            turnover: new Intl.NumberFormat("en-US", num_format).format(vipval.minTurnoverTierUpgrade),
            relegation: new Intl.NumberFormat("en-US", num_format).format(vipval.turnoverTierMaintain),
            depositRelegation: new Intl.NumberFormat("en-US", num_format).format(vipval.depositTierMaintain),
        });
        return null;
    });

    const currentSelectVipPrizesList = this.props.vipLevelRequirementAndReward?.data?.vip_levels[currentVip ? currentVip - 1 : 0]?.days || [];

    return (
      <Auxiliary>
        {this.state.loading && <LoadingPage />}
        {
          isDesktop ? (
            <section className='check-in-section'>              
              <div className="banner-col">
                <div className="banner-item">
                  <img src={`${process.env.REACT_APP_S3_URL}/images/check-in/web-banner/check-in${imageLanguage}.webp`} alt="R77 Promos" />
                </div>
              </div>

              <div className='x-container'>
                <div className='section-header-blue'>
                  <h2>{t('check_in.title_1')}</h2>
                  <p>{t('check_in.title_2')}</p>
                  {
                    (this.state.start_day && this.state.end_day) &&
                    <p className='event-date'>
                      <span>{t('check_in.time_1')}：</span>                                                
                      <span>{this.state.start_day}</span>
                      <span className='px-2'>-</span>
                      <span>{this.state.end_day}</span>
                    </p>
                  }
                </div>

                <div className='check-in-header'>
                  <img src={img['check-in-title-bg.webp']} alt='check-in background'/>
                  <h2>{t('check_in.weekly-rewards')}</h2>
                </div>                

                <div className='check-in-main-container'>

                  {/* Notice */}
                  <div className='check-in-notice'>
                    <img src={icon['bell.svg']} alt='bell'/>
                    <p>{t('check_in.notice')}</p>                    
                  </div>

                  {/* VIPs */}      
                  <div className='vips-container'>
                    {customizedVip.map((vipVal, idx) => {
                        return (
                            <div className='d-flex flex-column'>
                              <div className={`vip-badge ${this.state.currentVip === vipVal.level ? "active" : ""}`} onClick={() => this.handleVipLvl(vipVal.level)}>
                                  <img src={vip[`vip${vipVal.level}.webp`]} alt="vip-badge"/>
                                  {t(`vip.vip-${vipVal.level}`)}                                  
                              </div>
                              {this.state.memberProgress.vipLevel === vipVal.level && (
                                <div className='badge-title'>
                                  {t('vip.current-lvl')}
                                </div>
                              )}
                            </div>
                        );
                    })}        
                  </div>

                  <div className='divider'/>
                  
                  {/* Daily Check-In Rewards Based on VIP Select */}
                  <div className="d-flex justify-content-center">
                    <MemberProgress isCheckInPage={isCheckInPage} currentSelectVip={this.state.currentVip}/>
                  </div>
                </div>

                {/* Claim CheckIn Bonus Table */}
                <div className='section-header-gray'>
                  <h2>{t('check_in.claim-check-in-bonus')}</h2>
                  <p>{t('check_in.claim-check-in-bonus-notice')}</p>
                </div>
                
                <div>
                  {currentSelectVipPrizesList.length > 0 &&
                    <div className='claim-bonus-table'>                      
                      <table className='table'>
                        <thead>
                          <tr>
                            <th style={{ verticalAlign: 'top' }}>{t("check_in.daily-deposit-requirement")}</th>
                            <th style={{ verticalAlign: 'middle' }}><img src={img['cash.webp']} alt="bonus" style={{ width: '60px', height: 'auto' }} /></th>
                            <th style={{ verticalAlign: 'middle' }}><img src={img['coin.webp']} alt="coins" style={{ width: '60px', height: 'auto' }} /></th>
                            <th style={{ verticalAlign: 'middle' }}><img src={img['spin.webp']} alt="free-spins" style={{ width: '60px', height: 'auto' }} /></th>
                            <th style={{ verticalAlign: 'top' }}>{t("check_in.turnover-requirements")}</th>
                            <th style={{ verticalAlign: 'top' }}>{t("check_in.weekly-check-bonus")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            currentSelectVipPrizesList.map((item, index) => (
                              <tr key={index}>
                                <td className='number'>{item.required_deposit}</td>
                                <td className='number'>{item.reward_credit}</td>
                                <td className='number'>{item.reward_coin}</td>
                                <td className='number'>{item.reward_total_free_spin}</td>
                                <td className='number'>{item.turnover_multiplier}</td>
                                <td className='number'>{item.extra_reward_credit}</td>
                              </tr>
                            ))
                          }
                        </tbody>
                      </table>
                    </div>
                  }
                </div>

                {/* TNC */}
                <div className='section-header-gray'>
                  <h3>{t('check_in.rule-header')}</h3>                  
                </div>

                <div className='info-center-section'>
                  <div className="row">
                    <div className="info-content">                        
                      <div className="tab-content">
                        <div className="tab-pane fade show active info-tnc" id="tnc-main">                    
                          <ol className="tnc-custom-list">
                              <label>1</label>
                              <li>
                                {t('check_in.rule-1.1')} {""}
                                {this.state.start_day} 00:00:00am (GMT+08) {""}
                                {t('check_in.rule-1.2')} {""}
                                {this.state.end_day} 23:59:59pm (GMT+08) {""}
                                {t('check_in.rule-1.3')}
                              </li>
                            
                              <label>2</label>
                              <li>{t('check_in.rule-2')}</li>
                            
                              <label>3</label>
                              <li>{t('check_in.rule-3')}</li>
                            
                              <label>4</label>
                              <li>{t('check_in.rule-4')}</li>                              
                          
                              <label>5</label>
                              <li>{t('check_in.rule-5')}</li>                              
                            
                              <label>6</label>
                              <li>{t('check_in.rule-6')}</li>                              
                            
                              <label>7</label>
                              <li>{t('check_in.rule-7')}</li>                              
                          
                              <label>8</label>
                              <li>{t('check_in.rule-8')}</li>                              
                          
                              <label>9</label>
                              <li>{t('check_in.rule-9')}</li>                              
                            
                              <label>10</label>
                              <li>{t('check_in.rule-10')}</li>                              
                          
                              <label>11</label>
                              <li>{t('check_in.rule-11')}</li>                              
                          
                              <label>12</label>
                              <li>{t('check_in.rule-12')}</li>                              
                          </ol>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <MobileCheckIn
              start_day={this.state.start_day}
              end_day={this.state.end_day}
              claimBonusHandler={this.claimBonusHandler}
              icon={icon}
              vip={vip}
              customizedVip={customizedVip}
              prevPage={prevPage}
              handleVipLvl={this.handleVipLvl}
              currentVip={this.state.currentVip}
              isCheckInPage={isCheckInPage}
              memberProgress={this.state.memberProgress}
              currentSelectVipPrizesList={currentSelectVipPrizesList}
            />
          )
        }
      </Auxiliary>
    )
  }
}

const mapStateToProps = (state) => {
  const { vip } = state;

  return {
    currentUser: state.currentUser.data,
    daily_mission: state.dailyMission.daily_mission,
    daily_mission_bonuses: state.dailyMission.daily_mission_bonuses,
    daily_mission_bonus_claim: state.dailyMission.daily_mission_bonus_claim,
    daily_mission_extra_bonus_claim: state.dailyMission.daily_mission_extra_bonus_claim,
    vip_data: vip.vip_data,
    memberProgress: state.dailyCheckIn?.memberProgress?.data || {},
    vipLevelRequirementAndReward: state.dailyCheckIn?.vipLevelRequirementAndReward?.data || {}
  }
}

const mapDispatchToProps = {
  getDailyMission,
  getDailyMissionBonuses,
  claimDailyBonus,
  claimExtraBonus,
  getVIP,
  getMemberProgress,
  getVipLevelRequirementAndReward,
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(CheckIn));